import React from "react";

import { StyledSVG } from "../StyledIcon";

export const Fridaycon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 60 60"
      fill="none"
      {...props}
    >
      <rect width="60" height="60" fill="white" vectorEffect="non-scaling-stroke" />
      <path
        d="M11 22.8571C11.2245 18.2093 13.1953 13.797 16.5466 10.4917C20.1118 6.97544 24.9473 5 29.9892 5C35.0312 5 39.8667 6.97544 43.4319 10.4917C46.7831 13.797 48.754 18.2093 48.9785 22.8571L49 38.9286H45.7299C45.6559 40.9142 45.2122 42.8728 44.4179 44.7114C43.5444 46.7335 42.2641 48.5708 40.6501 50.1184C39.0361 51.6661 37.12 52.8937 35.0112 53.7313C32.9025 54.5689 30.6423 55 28.3597 55H11L11 22.8571Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M41.8671 22.8742C41.0193 28.354 30.0274 36 30.0274 36C26.3478 34.2496 18.819 27.7739 18.1411 22.8742C17.2938 16.7495 20.4237 15 23.2251 15C25.8119 15 27.4595 16.3674 30.0027 19.1836C32.0903 16.378 34.234 14.9999 36.7815 15C39.3276 15.0001 42.7149 17.3943 41.8671 22.8742Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </StyledSVG>
  );
};
